var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.editor)?_c('div',[_c('menu-bar',{staticClass:"editor__header",attrs:{"editor":_vm.editor}},[_vm._t("default")],2),_c('div',{staticClass:"editor"},[_c('editor-content',{attrs:{"editor":_vm.editor}})],1),_c('div',{staticClass:"editor__footer"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }